var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTajikistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_17284)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_17284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_17284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 17.2886H1V23H35.2819V17.2886Z",
    fill: "#58B44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 8.70472H1V17.2819H35.2819V8.70472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V8.71142H35.2819V3Z",
    fill: "#EA0042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1142 15.0254C18.2816 15.2263 18.8842 15.4339 19.3997 15.1727C19.4801 15.4138 20.1229 15.8088 20.7054 15.387C20.076 15.3 19.7345 15.0924 19.3863 14.6237C19.0382 14.9049 18.469 14.6505 18.3418 14.5166L18.3485 12.8962L19.1788 12.0793C19.1788 11.9053 18.6431 11.4031 18.1142 11.4031C17.5785 11.4031 17.0495 11.8986 17.0495 12.0793L17.8798 12.8962L17.8865 14.5166C17.7593 14.6505 17.1902 14.8982 16.842 14.6237C16.4938 15.0924 16.1523 15.3 15.5229 15.387C16.0988 15.8088 16.7482 15.4138 16.8286 15.1727C17.3442 15.4406 17.9468 15.2263 18.1142 15.0254ZM18.1142 12.6217C17.9066 12.2668 17.4848 12.1329 17.4848 12.1329C17.4848 12.1329 17.699 11.7847 18.1142 11.7847C18.5293 11.7847 18.7436 12.1329 18.7436 12.1329C18.7436 12.1329 18.3217 12.2668 18.1142 12.6217Z",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1142 15.8691C17.3508 15.8691 16.8688 16.1369 16.621 16.4181L16.4068 16.1905C16.6009 15.9561 16.8621 15.8691 16.9223 15.5745C16.9893 15.3669 16.842 15.2062 16.842 15.2062C16.842 15.2062 17.0562 15.5008 17.5919 15.5008C17.92 15.5008 18.1208 15.1393 18.1208 15.1393M18.1142 15.1326C18.1142 15.1326 18.315 15.4941 18.6431 15.4941C19.1788 15.4941 19.393 15.1995 19.393 15.1995C19.393 15.1995 19.2457 15.3602 19.3127 15.5678C19.3796 15.8624 19.6408 15.9494 19.8282 16.1838L19.614 16.4115C19.3595 16.1302 18.8775 15.8624 18.1208 15.8624",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7834 13.2176L21.9307 13.6662H22.3994L22.0177 13.9407L22.165 14.3827L21.7834 14.1081L21.4084 14.3827L21.5557 13.9407L21.1741 13.6662H21.6428L21.7834 13.2176Z",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2946 11.3964L21.4419 11.8383H21.9106L21.529 12.1128L21.6763 12.5614L21.2946 12.2869L20.9197 12.5614L21.067 12.1128L20.6853 11.8383H21.154L21.2946 11.3964Z",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9622 10.0639L20.1095 10.5059H20.5782L20.1965 10.7804L20.3438 11.229L19.9622 10.9478L19.5872 11.229L19.7278 10.7804L19.3529 10.5059H19.8216L19.9622 10.0639Z",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 9.57516L18.2882 10.0171H18.7502L18.3753 10.2916L18.5159 10.7402L18.1409 10.4657L17.766 10.7402L17.9066 10.2916L17.5316 10.0171H17.9936L18.1409 9.57516Z",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3197 10.0639L16.4603 10.5059H16.929L16.5541 10.7804L16.6947 11.229L16.3197 10.9478L15.9381 11.229L16.0854 10.7804L15.7037 10.5059H16.1724L16.3197 10.0639Z",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9873 11.3964L15.1279 11.8383H15.5966L15.2149 12.1128L15.3622 12.5614L14.9873 12.2869L14.6056 12.5614L14.7529 12.1128L14.3713 11.8383H14.84L14.9873 11.3964Z",
    fill: "#CFB428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4985 13.2176L14.6391 13.6662H15.1078L14.7261 13.9407L14.8735 14.3827L14.4985 14.1081L14.1168 14.3827L14.2641 13.9407L13.8825 13.6662H14.3512L14.4985 13.2176Z",
    fill: "#CFB428"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_17284",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_17284"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_17284",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajikistan);
export default __webpack_public_path__ + "static/media/Tajikistan.07127ee9b8f0ae0a697a2dccd02dff77.svg";
export { ForwardRef as ReactComponent };